import { colors } from '@globals/themes/defaultTheme'
import { styled } from '@mui/material/styles'

export const MOBILE_HEIGHT = 300
export const MOBILE_MAX_HEIGHT = 360
export const DESKTOP_HEIGHT = 400
export const DESKTOP_MAX_HEIGHT = 320
export const DEFAULT_POSITION = 60

const getTopPosition = (position: 'top' | 'bottom', isMobile: boolean): number => {
  if (position === 'top') {
    return isMobile ? -MOBILE_MAX_HEIGHT : -DESKTOP_MAX_HEIGHT
  } else {
    return DEFAULT_POSITION
  }
}

type EmojiPickerWrapperProps = {
  position: 'top' | 'bottom'
  isMobile: boolean
}

export const EmojiPickerWrapper = styled('div')<EmojiPickerWrapperProps>(
  ({ position, isMobile }) => ({
    position: 'absolute',
    top: getTopPosition(position, isMobile),
    right: 0,
    zIndex: 10,
    maxHeight: isMobile ? MOBILE_MAX_HEIGHT : DESKTOP_MAX_HEIGHT,
    overflowY: 'auto',
    boxShadow: colors.boxShadow,
    borderRadius: '8px',
  }),
)
